export const fileToDataURL = (file: File | Blob): Promise<string> =>
  new Promise(
    (
      resolve: (value: string | PromiseLike<string>) => void,
      reject: (reason?: any) => void
    ) => {
      const reader: FileReader = new FileReader();
      reader.onload = () => {
        resolve(reader.result as string);
      };

      reader.readAsDataURL(file);
      reader.onerror = (error: ProgressEvent<FileReader>) => reject(error);
    }
  );

export const fileToBase64 = async (
  file: File | Blob
): Promise<string | null> => {
  const dataUrl: string = await fileToDataURL(file);
  try {
    return dataUrl.split('base64,')[1];
  } catch {
    return null;
  }
};

export const base64ToDataUrl = (mimetype: string, base64: string): string => {
  return `data:${mimetype};base64,${base64}`;
};

export const dataURLToFile = (
  dataUrl: string,
  filename: string = 'file'
): File => {
  const arr = dataUrl.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};
